import Vue from "vue";
import VueMeta from "vue-meta";
import Router from "vue-router";
import HomePage from "@/components/pages/Home";
import Search from "@/components/pages/Search/Search";
import UniversityAbout from "@/components/pages/University Detail/About";
import CountryAbout from "@/components/pages/Country/About";
import Edgeout from "@/components/pages/Edgeout";
import Aboutus from "@/components/pages/Aboutus";
import CareerCounselling from "@/components/pages/CareerCounselling";
import AbroadCounselling from "@/components/pages/AbroadCounselling";
import StudyAbroadCounsellingOld from "@/components/pages/StudyAbroadCounsellingOld";
import StudyAbroadCounsellingMumbai from "@/components/pages/StudyAbroadCounsellingMumbai";
import StudyAbroadCounsellingDubai from "@/components/pages/StudyAbroadCounsellingDubai";
import StudyAbroadCounsellingNearMe from "@/components/pages/StudyAbroadCounsellingNearMe";
import StudyAbroadCounsellingHyd from "@/components/pages/StudyAbroadCounsellingHyd";
import StudyAbroadCounsellingIndia from "@/components/pages/StudyAbroadCounsellingIndia";
import StudyAbroadCounsellingPune from "@/components/pages/StudyAbroadCounsellingPune";
import StudyAbroadCounsellingGermany from "@/components/pages/StudyAbroadCounsellingGermany";
import AliffBlog from "@/components/pages/Blogs/MainBlog";
import Blog from "@/components/pages/Blogs/Blog";
import FranchiseLocations from "@/components/pages/FranchiseLocations";
import Franchise from "@/components/pages/Franchise";
import MicroFranchise from "@/components/pages/MicroFranchise";
import JahangairMicroFranchise from "@/components/pages/JahangairMicroFranchise.vue";

import StudyAbroadFairNew from "@/components/pages/StudyAbroadFairNew";

import StudyAbroadFair1 from "@/components/pages/StudyAbroadFair1";
import StudyAbroadFair2 from "@/components/pages/StudyAbroadFair2";
import StudyAbroadFair3 from "@/components/pages/StudyAbroadFair3";
import StudyAbroadFair4 from "@/components/pages/StudyAbroadFair4";
import StudyAbroadFair5 from "@/components/pages/StudyAbroadFair5";
import StudyAbroadFair6 from "@/components/pages/StudyAbroadFair6";

import BlogOne from "@/components/pages/Blogs/Blog-1";
import BlogTwo from "@/components/pages/Blogs/Blog-2";
import BlogThree from "@/components/pages/Blogs/Blog-3";
import BlogFour from "@/components/pages/Blogs/Blog-4";
import BlogFive from "@/components/pages/Blogs/Blog-5";
import BlogSix from "@/components/pages/Blogs/Blog-6";
import BlogSeven from "@/components/pages/Blogs/Blog-7";
import BlogEight from "@/components/pages/Blogs/Blog-8";
import BlogNine from "@/components/pages/Blogs/Blog-9";
import BlogDetail from "@/components/pages/Blogs/BlogDetail";

import ChooseUsaDiscoverYourProspectsInTheLandOfDream from "@/components/pages/Blogs/ChooseUsaDiscoverYourProspectsInTheLandOfDream";
import DiscoverNewAgeCoursesStudyInTheUK from "@/components/pages/Blogs/DiscoverNewAgeCoursesStudyInTheUK";
import EducationConsultantsGivingYouTheWinningEdge from "@/components/pages/Blogs/EducationConsultantsGivingYouTheWinningEdge";
import ExpertConsultancyForForeignEducation from "@/components/pages/Blogs/ExpertConsultancyForForeignEducation";
import FulfilYourUsEducationDreamsWithTopUsaEducationConsultants from "@/components/pages/Blogs/FulfilYourUsEducationDreamsWithTopUsaEducationConsultants";
import OverseasEducationConsultantsHelpingYouMakeTheRightDecisions from "@/components/pages/Blogs/OverseasEducationConsultantsHelpingYouMakeTheRightDecisions";
import StudyAbroadAfter12thScienceToBuildYourCareer from "@/components/pages/Blogs/StudyAbroadAfter12thScienceToBuildYourCareer";
import TakeTheRoadLessTravelledStudyInIreland from "@/components/pages/Blogs/TakeTheRoadLessTravelledStudyInIreland";
import Top3CareerTipsFromIrelandEducationConsultants from "@/components/pages/Blogs/Top3CareerTipsFromIrelandEducationConsultants";
import WorldClassEducationInATaxFreeCountry from "@/components/pages/Blogs/WorldClassEducationInATaxFreeCountry";
import YourForeignEducationChecklistSorted from "@/components/pages/Blogs/YourForeignEducationChecklistSorted";
import YourMoneysWorthCheapestCountriesToStudyAbroad from "@/components/pages/Blogs/YourMoneysWorthCheapestCountriesToStudyAbroad";
import BoonsForYourCareerFromCanadaEducationConsultants from "@/components/pages/Blogs/BoonsForYourCareerFromCanadaEducationConsultants";
import UniversitiesToLookOutForToStudyInUk from "@/components/pages/Blogs/UniversitiesToLookOutForToStudyInUk";
import OverseasEducationConsultantsHandholdingYouToGlobalSuccess from "@/components/pages/Blogs/OverseasEducationConsultantsHandholdingYouToGlobalSuccess";
import ForeignEducationConsultancyStreamliningYourEveryAdmissionProcess from "@/components/pages/Blogs/ForeignEducationConsultancyStreamliningYourEveryAdmissionProcess";
import StudyInDubaiGetAModernEducationalExperience from "@/components/pages/Blogs/StudyInDubaiGetAModernEducationalExperience";

import AllifTvScreen from "@/components/pages/AllifTvScreen";
import Sef from "@/components/pages/sef";
import SefApi from "@/components/pages/sefApi";
// import Accomodations from "@/components/pages/Accomodations"

import TermsandServices from "@/components/pages/TermsandServices";
import PrivacyPolicy from "@/components/pages/PrivacyPolicy";
import RefundPolicy from "@/components/pages/RefundPolicy";
import CancellationRefundPolicy from "../components/pages/CancellationRefundPolicy";

import Sitemap from "@/components/pages/Sitemap";

import Ielts from "@/components/pages/Ielts";
import ContactUs from "@/components/pages/ContactUs";

import Login from "@/components/pages/Login";

//Common Forms

import ScholarshipForm from "@/components/forms/ScholarshipForm";
import NavRegister from "@/components/forms/NavRegister";

//Student Enquiry Form
import StudentEnquiryForm from "@/components/pages/StudentEnquiryForm";

//Events Page
import EventsPage from "@/components/pages/EventsPage";

// Careers
import AliffCareers from "@/components/pages/AliffCareers/AliffCareers.vue";
import AliffPremiumPackage from "@/components/pages/AliffPremiumPackages.vue";

//Associate
import AssociatePage from "@/components/pages/AssociatePage.vue";
import FranchisePage from "@/components/pages/FranchisePage.vue";

import ThaneFranchisePage from "@/components/pages/ThaneFranchisePage.vue";
import GujratFranchisePage from "@/components/pages/GujratFranchisePage.vue";
import MiraRoadFranchisePage from "@/components/pages/MiraRoadFranchisePage.vue";
import LowerParelFranchisePage from "@/components/pages/LowerParelFranchisePage.vue";
import RaipurFranchisePage from "@/components/pages/RaipurFranchisePage.vue";
import SolapurFranchisePage from "@/components/pages/SolapurFranchisePage.vue";
import NaviMumbaiFranchisePage from "@/components/pages/NaviMumbaiFranchisePage.vue";
import KarnatakaFranchisePage from "@/components/pages/KarnatakaFranchisePage.vue";
import DubaiFranchisePage from "@/components/pages/DubaiFranchisePage.vue";
import KuwaitFranchisePage from "@/components/pages/KuwaitFranchisePage.vue";
import PuneFranchisePage from "@/components/pages/PuneFranchisePage.vue";
import PimpleFranchisePage from "@/components/pages/PimpleFranchisePage.vue";
import CoimbatoreFranchisePage from "@/components/pages/CoimbatoreFranchisePage.vue";
import KarveRoadFranchisePage from "@/components/pages/KarveRoadFranchisePage.vue";
import DeccanFranchisePage from "@/components/pages/DeccanFranchisePage.vue";
import storeLocatorPage from "@/components/pages/storeLocator.vue";
import ForeignStudyConsultancy from "@/components/pages/foreignStudyConsultancy.vue";
import ChennaiFranchisePage from "@/components/pages/ChennaiFranchisePage.vue";
import StudyAbroad from "@/components/partials/StudyAbroad.vue";
import OMRChennaiOffice from "@/components/pages/OMRChennaiOffice.vue";
import KolkataFranchisePage from "@/components/pages/KolkataFranchisePage.vue";
import IeltsDoc from "@/components/partials/IeltsDoc.vue";
import GhanaFranchisePage from "@/components/pages/GhanaFranchisePage.vue";
import ChennaiMicroFranchiseOne from "@/components/pages/ChennaiMicroFranchiseOne.vue";
import VashiFranchisePage from "@/components/pages/VashiFranchisePage.vue";
import MumbaiFranchiseMicro from "@/components/pages/MumbaiFranchiseMicro.vue";
import SolapurMicroFranchisePage from "@/components/pages/SolapurMicroFranchisePage.vue";
import PuneFranchisePankaj from "@/components/pages/PuneFranchisePankaj.vue";
import KalyanFranchise from "@/components/pages/KalyanFranchise.vue";

import LowerParel from "@/components/pages/VirtualFair/Lowerparel.vue";
import Bandra from "@/components/pages/VirtualFair/Bandra.vue";
import Thane from "@/components/pages/VirtualFair/Thane.vue";
import MiraRoad from "@/components/pages/VirtualFair/MiraRoad.vue";
import Belapur from "@/components/pages/VirtualFair/Belapur.vue";
import Vashi from "@/components/pages/VirtualFair/Vashi.vue";
import SolapurOffice from "@/components/pages/VirtualFair/SolapurOffice.vue";
import SolapurHarshada from "@/components/pages/VirtualFair/SolapurHarshada.vue";
import Hubballi from "@/components/pages/VirtualFair/Hubballi.vue";
import DeccanPune from "@/components/pages/VirtualFair/DeccanPune.vue";
import KarveRoadPune from "@/components/pages/VirtualFair/KarveRoadPune.vue";
import PimpliSaudagar from "@/components/pages/VirtualFair/PimpliSaudagar.vue";
import VimanNagar from "@/components/pages/VirtualFair/VimanNagar.vue";
import Coimbatore from "@/components/pages/VirtualFair/Coimbatore.vue";
import OMRChennai from "@/components/pages/VirtualFair/OMRChennai.vue";
import AmbatturChennai from "@/components/pages/VirtualFair/AmbatturChennai.vue";
import KolkataOffice from "@/components/pages/VirtualFair/KolkataOffice.vue";
import Raipur from "@/components/pages/VirtualFair/Raipur.vue";

import MainPage from "@/components/pages/SolapurFair/MainPage.vue";
import PuneFairPage from "@/components/pages/PuneFair/PuneFairPage.vue";
import MultiStepForm from "@/components/forms/MultistepFormForFinder/MultiStepForm.vue";
import MainBlogPage from "@/components/pages/NewBlogs/MainBlogPage.vue";
import ChennaiMicroFranchiseTwo from "@/components/pages/ChennaiMicroFranchiseTwo.vue";
import ThankyouPage from "@/components/partials/ThankyouPage.vue";
import MBBS from "@/components/pages/MBBSFair/MBBS.vue";

// MBBS Fair
import {
  AmbatturChennaiMBBS,
  BandraMBBS,
  BelapurMBBS,
  CoimbatoreMBBS,
  DeccanPuneMBBS,
  HubballiMBBS,
  KarveRoadPuneMBBS,
  KolkataOfficeMBBS,
  LowerParelMBBS,
  MiraRoadMBBS,
  OMRChennaiMBBS,
  PimpliSaudagarMBBS,
  RaipurMBBS,
  SolapurHarshadaMBBS,
  SolapurOfficeMBBS,
  ThaneMBBS,
  VashiMBBS,
  VimanNagarMBBS,
  KalyanMBBS,
  SangliMBBS,
} from "@/components/pages/MBBSFair/index";
import IeltsDemo from "@/components/pages/IeltsDemo/IeltsDemo.vue";
import SangliFranchise from "@/components/pages/SangliFranchise.vue";

Vue.use(VueMeta);
Vue.use(Router);

const router = new Router({
  mode: "history",
  scrollBehavior: () => {
    return {
      x: 0,
      y: 0,
    };
  },

  routes: [
    {
      path: "/",
      name: "home",
      component: HomePage,
    },
    {
      path: "/login",
      name: "Login",
      component: Login,
    },
    {
      path: "/chances-of-scholarship",
      name: "ScholarshipForm",
      component: ScholarshipForm,
    },
    {
      path: "/register",
      name: "NavRegister",
      component: NavRegister,
    },
    {
      path: "/search/:search",
      name: "Search",
      component: Search,
      props: true,
    },
    {
      path: "/edgeout",
      name: "Edgeout",
      component: Edgeout,
    },
    {
      path: "/aliff-premium",
      name: "Aliff Premium Package",
      component: AliffPremiumPackage,
    },
    {
      path: "/franchise-locations",
      name: "FranchiseLocations",
      component: FranchiseLocations,
    },
    {
      path: "/franchise",
      name: "Franchise",
      component: Franchise,
    },
    {
      path: "/about-us",
      name: "Aboutus",
      component: Aboutus,
    },
    {
      path: "/ielts",
      name: "Ielts",
      component: Ielts,
    },
    {
      path: "/abroad-counselling",
      name: "AbroadCounselling",
      component: AbroadCounselling,
    },
    {
      path: "/study-abroad-consultants",
      name: "StudyAbroadCounselling",
      component: StudyAbroadCounsellingOld,
    },
    {
      path: "/study-abroad-consultants-mumbai",
      name: "StudyAbroadCounsellingMumbai",
      component: StudyAbroadCounsellingMumbai,
    },
    {
      path: "/study-abroad-consultants-in-dubai",
      name: "StudyAbroadCounsellingDubai",
      component: StudyAbroadCounsellingDubai,
    },
    {
      path: "/study-abroad-consultants-near-me",
      name: "StudyAbroadCounsellingNearMe",
      component: StudyAbroadCounsellingNearMe,
    },
    {
      path: "/study-abroad-consultants-hyderabad",
      name: "StudyAbroadCounsellingHyd",
      component: StudyAbroadCounsellingHyd,
    },
    {
      path: "/study-abroad-consultants-in-india",
      name: "StudyAbroadCounsellingIndia",
      component: StudyAbroadCounsellingIndia,
    },
    {
      path: "/study-abroad-consultants-pune",
      name: "StudyAbroadCounsellingPune",
      component: StudyAbroadCounsellingPune,
    },
    {
      path: "/study-abroad-consultants-in-germany",
      name: "StudyAbroadCounsellingGermany",
      component: StudyAbroadCounsellingGermany,
    },
    {
      path: "/career-counselling",
      name: "CareerCounselling",
      component: CareerCounselling,
    },
    {
      path: "/fair",
      name: "StudyAbroadFair",
      component: StudyAbroadFairNew,
    },

    {
      path: "/fair-1",
      name: "StudyAbroadFair1",
      component: StudyAbroadFair1,
    },
    {
      path: "/fair-2",
      name: "StudyAbroadFair2",
      component: StudyAbroadFair2,
    },
    {
      path: "/fair-3",
      name: "StudyAbroadFair3",
      component: StudyAbroadFair3,
    },
    {
      path: "/virtual-fair",
      name: "StudyAbroadFair4",
      component: StudyAbroadFair4,
    },
    {
      path: "/fair-5",
      name: "StudyAbroadFair5",
      component: StudyAbroadFair5,
    },
    {
      path: "/fair-6",
      name: "StudyAbroadFair6",
      component: StudyAbroadFair6,
    },
    {
      path: "/tv-screen",
      name: "AllifTvScreen",
      component: AllifTvScreen,
    },
    {
      path: "/sef-npf",
      name: "sef",
      component: Sef,
    },
    {
      path: "/sef",
      name: "sefApi",
      component: SefApi,
    },
    // {
    //   path: "/accomodations",
    //   name: "Accomodations",
    //   component: Accomodations,
    // },
    {
      path: "/contact-us",
      name: "ContactUs",
      component: ContactUs,
    },
    {
      path: "/university-about/:university_id",
      name: "UniversityAbout",
      component: UniversityAbout,
    },
    {
      path: "/country-about/:country_key",
      name: "CountryAbout",
      component: CountryAbout,
    },
    {
      path: "/aliff-blog",
      name: "AliffBlog",
      component: AliffBlog,
    },
    {
      path: "/aliff-blogs-recent",
      name: "AliffBlogsRecent",
      component: MainBlogPage,
    },
    {
      path: "/aliff-blogs-recent/bg/:id/:title",
      name: "BlogDetail",
      component: BlogDetail,
      props: true,
    },
    {
      path: "/blogs/:id/:name",
      name: "Blog",
      component: Blog,
    },
    {
      path: "/blog/foreign-education-consultants-the-steppingstone-to-successfully-studying-abroad/",
      name: "Blog 1",
      component: BlogOne,
    },
    {
      path: "/blog/what-is-it-like-for-indian-students-to-study-in-ireland/",
      name: "Blog 2",
      component: BlogTwo,
    },
    {
      path: "/blog/top-5-reasons-that-prove-overseas-study-consultancy-is-advantageous/",
      name: "Blog 3",
      component: BlogThree,
    },
    {
      path: "/blog/how-do-i-decide-on-a-country-to-study-abroad/",
      name: "Blog 4",
      component: BlogFour,
    },
    {
      path: "/blog/how-to-chart-your-stem-career-after-12th/",
      name: "Blog 5",
      component: BlogFive,
    },
    {
      path: "/blog/ireland-emerging-education-hub-for-international-students/",
      name: "Blog 6",
      component: BlogSix,
    },
    {
      path: "/blog/significance-of-correct-consultancy-for-foreign-education-and-how-to-identify-the-best-overseas-education-consultants/",
      name: "Blog 7",
      component: BlogSeven,
    },
    {
      path: "/blog/studying-abroad-is-once-in-a-lifetime-opportunity-make-the-most-of-it/",
      name: "Blog 8",
      component: BlogEight,
    },
    {
      path: "/blog/usa-a-perfect-destination-for-live-the-american-dream-for-your-higher-studies/",
      name: "Blog 9",
      component: BlogNine,
    },
    {
      path: "/choose-usa-discover-your-prospects-in-the-land-of-dream",
      name: "ChooseUsaDiscoverYourProspectsInTheLandOfDream",
      component: ChooseUsaDiscoverYourProspectsInTheLandOfDream,
    },
    {
      path: "/discover-new-age-courses-study-in-the-uk",
      name: "DiscoverNewAgeCoursesStudyInTheUK",
      component: DiscoverNewAgeCoursesStudyInTheUK,
    },
    {
      path: "/education-consultants-giving-you-the-winning-edge",
      name: "EducationConsultantsGivingYouTheWinningEdge",
      component: EducationConsultantsGivingYouTheWinningEdge,
    },
    {
      path: "/expert-consultancy-for-foreign-education",
      name: "ExpertConsultancyForForeignEducation",
      component: ExpertConsultancyForForeignEducation,
    },
    {
      path: "/fulfil-your-us-education-dreams-with-top-usa-education-consultants",
      name: "FulfilYourUsEducationDreamsWithTopUsaEducationConsultants",
      component: FulfilYourUsEducationDreamsWithTopUsaEducationConsultants,
    },
    {
      path: "/overseas-education-consultants-helping-you-make-the-right-decisions",
      name: "OverseasEducationConsultantsHelpingYouMakeTheRightDecisions",
      component: OverseasEducationConsultantsHelpingYouMakeTheRightDecisions,
    },
    {
      path: "/study-abroad-after-12th-science-to-build-your-career",
      name: "StudyAbroadAfter12thScienceToBuildYourCareer",
      component: StudyAbroadAfter12thScienceToBuildYourCareer,
    },
    {
      path: "/take-the-road-less-travelled-study-in-ireland",
      name: "TakeTheRoadLessTravelledStudyInIreland",
      component: TakeTheRoadLessTravelledStudyInIreland,
    },
    {
      path: "/top-3-career-tips-from-ireland-education-consultants",
      name: "Top3CareerTipsFromIrelandEducationConsultants",
      component: Top3CareerTipsFromIrelandEducationConsultants,
    },
    {
      path: "/world-class-education-in-a-tax-free-country",
      name: "WorldClassEducationInATaxFreeCountry",
      component: WorldClassEducationInATaxFreeCountry,
    },
    {
      path: "/your-foreign-education-checklist-sorted",
      name: "YourForeignEducationChecklistSorted",
      component: YourForeignEducationChecklistSorted,
    },
    {
      path: "/your-moneys-worth-cheapest-countries-to-study-abroad",
      name: "YourMoneysWorthCheapestCountriesToStudyAbroad",
      component: YourMoneysWorthCheapestCountriesToStudyAbroad,
    },
    {
      path: "/5-boons-for-your-career-from-canada-education-consultants",
      name: "BoonsForYourCareerFromCanadaEducationConsultants",
      component: BoonsForYourCareerFromCanadaEducationConsultants,
    },
    {
      path: "/universities-to-look-out-for-to-study-in-uk",
      name: "UniversitiesToLookOutForToStudyInUk",
      component: UniversitiesToLookOutForToStudyInUk,
    },
    {
      path: "/overseas-education-consultants-handholding-you-to-global-success",
      name: "OverseasEducationConsultantsHandholdingYouToGlobalSuccess",
      component: OverseasEducationConsultantsHandholdingYouToGlobalSuccess,
    },
    {
      path: "/foreign-education-consultancy-streamlining-your-every-admission-process",
      name: "ForeignEducationConsultancyStreamliningYourEveryAdmissionProcess",
      component:
        ForeignEducationConsultancyStreamliningYourEveryAdmissionProcess,
    },
    {
      path: "/study-in-dubai-get-a-modern-educational-experience",
      name: "study-in-dubai-get-a-modern-educational-experience",
      component: StudyInDubaiGetAModernEducationalExperience,
    },
    {
      path: "/terms-and-services",
      name: "TermsandServices",
      component: TermsandServices,
    },
    {
      path: "/refund-policy",
      name: "RefundPolicy",
      component: RefundPolicy,
    },
    {
      path: "/privacy-policy",
      name: "PrivacyPolicy",
      component: PrivacyPolicy,
    },
    {
      path: "/cancellation-and-refund-policy",
      name: "Cancellation",
      component: CancellationRefundPolicy,
    },
    {
      path: "/sitemap",
      name: "Sitemap",
      component: Sitemap,
    },
    {
      path: "/student-enquiry-form",
      name: "StudentEnquiryForm",
      component: StudentEnquiryForm,
    },
    {
      path: "/events-page",
      name: "EventsPage",
      component: EventsPage,
    },
    {
      path: "/aliff-careers",
      name: "AliffCareers",
      component: AliffCareers,
    },
    {
      path: "/associate-page",
      name: "AssociatePage",
      component: AssociatePage,
    },
    {
      path: "/franchise-page",
      name: "FranchisePage",
      component: FranchisePage,
    },

    {
      path: "/thane-office",
      name: "ThaneFranchise",
      component: ThaneFranchisePage,
    },
    {
      path: "/vadodara-office",
      name: "GujratFranchise",
      component: GujratFranchisePage,
    },
    {
      path: "/miraroad-office",
      name: "MiraRoadFranchise",
      component: MiraRoadFranchisePage,
    },
    {
      path: "/lowerparel-office",
      name: "LowerParelFranchise",
      component: LowerParelFranchisePage,
    },
    {
      path: "/raipur-office",
      name: "RaipurFranchise",
      component: RaipurFranchisePage,
    },
    {
      path: "/solapur-office",
      name: "SolapurFranchise",
      component: SolapurFranchisePage,
    },
    {
      path: "/solapur-office-jahaangeer",
      name: "JahangairMicroFranchise",
      component: JahangairMicroFranchise,
    },
    {
      path: "/belapur-office",
      name: "NaviMumbaiFranchise",
      component: NaviMumbaiFranchisePage,
    },
    {
      path: "/hubballi-office",
      name: "KarnatakaFranchise",
      component: KarnatakaFranchisePage,
    },
    {
      path: "/dubai-office",
      name: "DubaiFranchise",
      component: DubaiFranchisePage,
    },
    {
      path: "/kuwait-office",
      name: "KuwaitFranchise",
      component: KuwaitFranchisePage,
    },
    // {
    //   path: "/pune-office",
    //   name: "PuneFranchise",
    //   component: PuneFranchisePage,
    // },
    {
      path: "/deccan-office",
      name: "DeccanFranchise",
      component: DeccanFranchisePage,
    },
    {
      path: "/karveRoad-office",
      name: "KarveRoadFranchise",
      component: KarveRoadFranchisePage,
    },
    {
      path: "/pimple-office",
      name: "PimpleFranchise",
      component: PimpleFranchisePage,
    },
    {
      path: "/coimbatore-office",
      name: "CoimbatoreFranchise",
      component: CoimbatoreFranchisePage,
    },
    {
      path: "/ambattur-chennai-office",
      name: "ChennaiFranchise",
      component: ChennaiFranchisePage,
    },
    {
      path: "/omr-chennai-office",
      name: "OMRChennaiFranchise",
      component: OMRChennaiOffice,
    },
    {
      path: "/kolkata-office",
      name: "KolkataFranchise",
      component: KolkataFranchisePage,
    },
    {
      path: "/ghana-office",
      name: "GhanaOffice",
      component: GhanaFranchisePage,
    },
    {
      path: "/chennai-office-radha",
      name: "ChennaiMicroRadhaFranchise",
      component: ChennaiMicroFranchiseOne,
    },
    {
      path: "/chennai-office-meena",
      name: "ChennaiMicroMeenaFranchise",
      component: ChennaiMicroFranchiseTwo,
    },
    {
      path: "/mumbai-micro-office",
      name: "MumbaiMicroOffice",
      component: MumbaiFranchiseMicro,
    },
    {
      path: "/solapur-micro-office",
      name: "SolapurMicroOffice",
      component: SolapurMicroFranchisePage,
    },
    {
      path: "/vashi-office",
      name: "VashiOffice",
      component: VashiFranchisePage,
    },
    {
      path: "/office-locator",
      name: "storeLocator",
      component: storeLocatorPage,
    },
    {
      path: "/micro-franchise",
      name: "microFranchise",
      component: MicroFranchise,
    },
    {
      path: "/foreign-study-consultancy",
      name: "foreignStudyConsultancy",
      component: ForeignStudyConsultancy,
    },
    {
      path: "/studyabroad",
      name: "StudyAbroad",
      component: StudyAbroad,
    },
    {
      path: "/presentation-doc/:ftp_id",
      name: "IeltsDoc",
      component: IeltsDoc,
    },
    {
      path: "/solapur-fair",
      name: "SolapurFair",
      component: MainPage,
    },
    {
      path: "/pune-fair",
      name: "PuneFair",
      component: PuneFairPage,
    },
    {
      path: "/virtual-fair-63",
      name: "LowerParelMBBS",
      component: LowerParelMBBS,
    },
    {
      path: "/virtual-fair-64",
      name: "BandraMBBS",
      component: BandraMBBS,
    },
    {
      path: "/virtual-fair-65",
      name: "ThaneMBBS",
      component: ThaneMBBS,
    },
    {
      path: "/virtual-fair-66",
      name: "MiraRoadMBBS",
      component: MiraRoadMBBS,
    },
    {
      path: "/virtual-fair-67",
      name: "BelapurMBBS",
      component: BelapurMBBS,
    },
    {
      path: "/virtual-fair-68",
      name: "VashiMBBS",
      component: VashiMBBS,
    },
    {
      path: "/virtual-fair-69",
      name: "SolapurOfficeMBBS",
      component: SolapurOfficeMBBS,
    },
    // {
    //   path: "/virtual-fair-70",
    //   name: "SolapurHarshadaMBBS",
    //   component: SolapurHarshadaMBBS,
    // },
    {
      path: "/virtual-fair-71",
      name: "HubballiMBBS",
      component: HubballiMBBS,
    },
    {
      path: "/virtual-fair-72",
      name: "DeccanPuneMBBS",
      component: DeccanPuneMBBS,
    },
    {
      path: "/virtual-fair-73",
      name: "KarveRoadPuneMBBS",
      component: KarveRoadPuneMBBS,
    },
    {
      path: "/virtual-fair-74",
      name: "PimpliSaudagarMBBS",
      component: PimpliSaudagarMBBS,
    },
    {
      path: "/virtual-fair-75",
      name: "VimanNagarMBBS",
      component: VimanNagarMBBS,
    },
    {
      path: "/virtual-fair-76",
      name: "CoimbatoreMBBS",
      component: CoimbatoreMBBS,
    },
    {
      path: "/virtual-fair-77",
      name: "OMRChennaiMBBS",
      component: OMRChennaiMBBS,
    },
    {
      path: "/virtual-fair-78",
      name: "AmbatturChennaiMBBS",
      component: AmbatturChennaiMBBS,
    },
    {
      path: "/virtual-fair-79",
      name: "KolkataOfficeMBBS",
      component: KolkataOfficeMBBS,
    },
    {
      path: "/virtual-fair-80",
      name: "RaipurMBBS",
      component: RaipurMBBS,
    },
    {
      path: "/virtual-fair-86",
      name: "KalyanMBBS",
      component: KalyanMBBS,
    },
    {
      path: "/virtual-fair-88",
      name: "SangliMBBS",
      component: SangliMBBS,
    },

    {
      path: "/multi-step-form",
      name: "MultiStepForm",
      component: MultiStepForm,
    },
    {
      path: "/pune-office-pankaj",
      name: "PuneFranchisePankaj",
      component: PuneFranchisePankaj,
    },
    {
      path: "/kalyan-office",
      name: "KalyanFranchise",
      component: KalyanFranchise,
    },
    {
      path: "/sangli-office",
      name: "SangliFranchise",
      component: SangliFranchise,
    },
    {
      path: "/ielts-demo",
      name: "IeltsDemo",
      component: IeltsDemo,
    },
    // {
    //   path: "/mbbs-fair-78",
    //   name: "AmbatturChennaiMBBS",
    //   component: AmbatturChennaiMBBS,
    // },
    // {
    //   path: "/mbbs-fair-64",
    //   name: "BandraMBBS",
    //   component: BandraMBBS,
    // },
    // {
    //   path: "/mbbs-fair-67",
    //   name: "BelapurMBBS",
    //   component: BelapurMBBS,
    // },
    // {
    //   path: "/mbbs-fair-76",
    //   name: "CoimbatoreMBBS",
    //   component: CoimbatoreMBBS,
    // },
    // {
    //   path: "/mbbs-fair-72",
    //   name: "DeccanPuneMBBS",
    //   component: DeccanPuneMBBS,
    // },
    // {
    //   path: "/mbbs-fair-71",
    //   name: "HubballiMBBS",
    //   component: HubballiMBBS,
    // },
    // {
    //   path: "/mbbs-fair-73",
    //   name: "KarveRoadPuneMBBS",
    //   component: KarveRoadPuneMBBS,
    // },
    // {
    //   path: "/mbbs-fair-79",
    //   name: "KolkataOfficeMBBS",
    //   component: KolkataOfficeMBBS,
    // },
    // {
    //   path: "/mbbs-fair-63",
    //   name: "LowerParelMBBS",
    //   component: LowerParelMBBS,
    // },
    // {
    //   path: "/mbbs-fair-66",
    //   name: "MiraRoadMBBS",
    //   component: MiraRoadMBBS,
    // },
    // {
    //   path: "/mbbs-fair-77",
    //   name: "OMRChennaiMBBS",
    //   component: OMRChennaiMBBS,
    // },
    // {
    //   path: "/mbbs-fair-74",
    //   name: "PimpliSaudagarMBBS",
    //   component: PimpliSaudagarMBBS,
    // },
    // {
    //   path: "/mbbs-fair-80",
    //   name: "RaipurMBBS",
    //   component: RaipurMBBS,
    // },
    // {
    //   path: "/mbbs-fair-70",
    //   name: "SolapurHarshadaMBBS",
    //   component: SolapurHarshadaMBBS,
    // },
    // {
    //   path: "/mbbs-fair-92",
    //   name: "SolapurOfficeMBBS",
    //   component: SolapurOfficeMBBS,
    // },
    // {
    //   path: "/mbbs-fair-69",
    //   name: "SolapurOfficeMBBS",
    //   component: SolapurOfficeMBBS,
    // },
    // {
    //   path: "/mbbs-fair-65",
    //   name: "ThaneMBBS",
    //   component: ThaneMBBS,
    // },
    // {
    //   path: "/mbbs-fair-68",
    //   name: "VashiMBBS",
    //   component: VashiMBBS,
    // },
    // {
    //   path: "/mbbs-fair-75",
    //   name: "VimanNagarMBBS",
    //   component: VimanNagarMBBS,
    // },

    // {
    //   path: "/thankyou",
    //   name: "ThankYouPage",
    //   component: ThankyouPage,
    // },
  ],
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js